
import {defineComponent, onMounted, PropType, reactive, watch} from "vue";
import InputText from "primevue/inputtext";
import {MasterDataColumn} from "@dex/squeeze-client-ts";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {charactersRegex} from "@/util/ValidationHelper";

export default defineComponent({
	name: "MasterDataColumnsForm",
	components: {
		InputText,
	},
	props: {
		masterDataColumn: {
			type: Object as PropType<MasterDataColumn>,
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		/** Current Object of all input-fields */
		const value = reactive<MasterDataColumn>({name: '', description: '', sourceColumn: ''});

		/** Determines the required rules for validation */
		const rules = {
			name: { required },
			description: { required },
			sourceColumn: { required, charactersRegex },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			Object.assign(value, props.masterDataColumn);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.masterDataColumn, () => {
			Object.assign(value, props.masterDataColumn);
		})

		/** Triggered on change of any field */
		const update = () => {
			emit("update", value, v$.value.$invalid);
		}

		return {
			value,
			props,
			v$,
			InputText,
			update,
		}
	},
});
